<div
  id="preloader"
  class="preloader"
  *ngIf="preloaderService.showPreloader"
  [class.fade-out]="!this.preloaderService.isLoading"
>
  <lottie-player
    src="../../../../assets/images/preloader/lottie.json"
    background="transparent"
    speed="1"
    style="width: 96px; height: 111px"
    loop
    autoplay
  ></lottie-player>
</div>
